<button
  type="button"
  [attr.aria-label]="ariaLabel()"
  [disabled]="disabled()"
  (click)="clicked.emit()"
  class="inline-flex h-10 items-center gap-2 cursor-pointer rounded-full border border-gray-200 bg-white px-4 text-sm font-semibold text-gray-600 shadow-sm transition-all hover:bg-gray-50 hover:text-gray-800 active:scale-95 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
  [class]="colorClass()"
>
  @if (icon()) {
    <span class="flex items-center justify-center">
      <ng-content select="[icon]" />
    </span>
  }
  @if (label()) {
    <span>{{ label() }}</span>
  }
</button>
